import { CreateCampaignComponent } from './create-campaign/create-campaign.component';
import { CampaignListComponent } from './campaign-list/campaign-list.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService as AuthGuard } from '../auth/auth-guard.service';

const routes: Routes = [
    {
        path: '',
        component: CampaignListComponent,
        canActivate: [AuthGuard]
    }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        TranslateModule.forChild(),
        RouterModule.forChild(routes),
    ],
    declarations: [
        CampaignListComponent,
        CreateCampaignComponent
    ]
})
export class CampaignsModule { }
